import { render, staticRenderFns } from "./SuggestLinkCard.vue?vue&type=template&id=fe675176&scoped=true"
import script from "./SuggestLinkCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestLinkCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SuggestLinkCard.vue?vue&type=style&index=0&id=fe675176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe675176",
  null
  
)

export default component.exports